/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const PerksFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M19.6503 11.3501H26.3203C27.4803 9.70008 27.8103 8.06008 27.0003 7.27008C26.7003 6.98008 26.2703 6.83008 25.7703 6.83008C24.6903 6.83008 23.2403 7.47008 21.9103 8.60008C20.5803 7.47008 19.1303 6.83008 18.0503 6.83008C17.5403 6.83008 17.1203 6.97008 16.8103 7.27008C16.0003 8.05008 16.3403 9.70008 17.4903 11.3501H19.6403H19.6503Z"
      fill="#000"
    />
    <path
      d="M36.4203 14.5098C36.3603 14.5098 36.3104 14.5098 36.2504 14.5098H23.6104V19.3098H36.2504C37.1304 19.3098 37.8304 18.5998 37.8304 17.7298V16.0998C37.8304 15.2798 37.2104 14.5998 36.4104 14.5198L36.4203 14.5098Z"
      fill="#000"
    />
    <path d="M8.13965 35.5797C8.13965 36.4597 8.83965 37.1597 9.71965 37.1597H20.4496V22.4697H8.13965V35.5797Z" fill="#000" />
    <path d="M23.6204 37.1597H34.2904C35.1604 37.1597 35.8703 36.4597 35.8703 35.5797V22.4697H23.6104V37.1597H23.6204Z" fill="#000" />
    <path
      d="M19.0702 14.5098H7.75016C7.69016 14.5098 7.64016 14.5098 7.59016 14.5098C6.79016 14.5898 6.16016 15.2698 6.16016 16.0898V17.7198C6.16016 18.5898 6.87016 19.2998 7.74016 19.2998H20.4402V14.5098H19.8302H19.0602H19.0702Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default PerksFill
